import { useNavigate } from "react-router-dom";
import LoginForm from "src/components/pages/Auth/Login/LoginForm";
import { useIsOnline } from "src/hooks";

import { ForgotPassword, ForgotPasswordWrapper } from "./Login.styled";

interface Props {
  auditor?: boolean;
}

const Login = ({ auditor }: Props) => {
  const isOnline = useIsOnline();
  const navigate = useNavigate();
  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <>
      <LoginForm auditor={auditor} />
      {!auditor && isOnline && (
        <ForgotPasswordWrapper>
          <ForgotPassword onClick={handleForgotPassword}>
            Forgot Password
          </ForgotPassword>
        </ForgotPasswordWrapper>
      )}
    </>
  );
};

export default Login;
